import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

interface EncountersState {
  showExternalEncounters: boolean;
}

const initialState: EncountersState = {
  showExternalEncounters: false,
};

const slice = createSlice({
  name: "encounters",
  initialState,
  reducers: {
    toggleExternalEncounters(state: EncountersState): void {
      state.showExternalEncounters = !state.showExternalEncounters;
    },
    setExternalEncounters(
      state: EncountersState,
      action: PayloadAction<boolean>,
    ): void {
      state.showExternalEncounters = action.payload;
    },
  },
});

export const { toggleExternalEncounters, setExternalEncounters } =
  slice.actions;
export const { reducer } = slice;

export default slice;
